module.exports = ":host{position:fixed;top:0;left:0;width:100%;height:55px}\n"